import { Row, Col } from "antd";
import { withTranslation } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";
import { PaddingContainer } from "../ContactForm/styles";

interface SocialLinkProps {
  href: string;
  src: string;
  paddingRight?: string;
}

const Footer = ({ t }: any) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src, paddingRight = "0%" }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
        style={{ paddingRight }}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <>
      {/* <FooterSection>
        <Container>
          <PaddingContainer>
            <Row justify="space-between">
              <Col lg={8} md={8} sm={12} xs={12}>
                <Language>{t("Contact")}</Language>
                <a href="mailto:heartoflifefloral@gmail.com">
                  <Large to="/">{t("Send us an email")}</Large>
                </a>
              </Col>
              <Col lg={8} md={8} sm={12} xs={12}>
                <Title>{t("Policy")}</Title>
                <Large to="/" left="true">
                  {t("Terms of Service")}
                </Large>
              </Col>
              <Col lg={8} md={8} sm={12} xs={12}>
                <Title>{t("Company")}</Title>
                <Large left="true" to="/">
                  {t("About")}
                </Large>
              </Col>
            </Row>
          </PaddingContainer>
        </Container>
      </FooterSection> */}
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <SvgIcon
                  src="logo.svg"
                  aria-label="homepage"
                  width="96px"
                  height="96px"
                />
              </LogoContainer>
            </NavLink>
            <FooterContainer>
              <SocialLink
                href="https://www.facebook.com/share/15qB8aCSsd/?mibextid=wwXIfr"
                src="facebook.png"
                paddingRight="25%"
              />
              <SocialLink
                href="https://www.instagram.com/heartoflifefloral"
                src="instagram.svg"
              />
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
